import PriceTable from '@front/blocks/dist/price-table';
import Reviews from '@front/blocks/dist/reviews';

import renderer from '../../utils/renderer';

renderer('[data-price-table]', PriceTable);
renderer('[data-reviews]', Reviews);
